/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * tripsReports
 * @export
 * @interface TripsRequest
 */
export interface TripsRequest {
    /**
     * 営業所ID
     * @type {number}
     * @memberof TripsRequest
     */
    officeId: number;
    /**
     * multiple営業所で検索のためのリスト
     * @type {Array<number>}
     * @memberof TripsRequest
     */
    officeIds?: Array<number>;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof TripsRequest
     */
    driverId: number;
    /**
     * 年月日
     * @type {number}
     * @memberof TripsRequest
     */
    shiftDate?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TripsRequest
     */
    getShiftIds?: Array<string>;
}

export function TripsRequestFromJSON(json: any): TripsRequest {
    return TripsRequestFromJSONTyped(json, false);
}

export function TripsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': json['office_id'],
        'officeIds': !exists(json, 'office_ids') ? undefined : json['office_ids'],
        'driverId': json['driver_id'],
        'shiftDate': !exists(json, 'shift_date') ? undefined : json['shift_date'],
        'getShiftIds': !exists(json, 'get_shift_ids') ? undefined : json['get_shift_ids'],
    };
}

export function TripsRequestToJSON(value?: TripsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_ids': value.officeIds,
        'driver_id': value.driverId,
        'shift_date': value.shiftDate,
        'get_shift_ids': value.getShiftIds,
    };
}


